<template>
    <section class="popup-small" v-show="$global.popup.open && $global.popup.id === id" >
        <div class="popup-blur"></div>
        <div class="popup-small-main">
            <div class="popup-small-close">
                <Close width="35" height="35" color="#000" @click="triggerPopup(false, null)" />
            </div>
            <div class="popup-small-content">
                <slot />
            </div>
        </div>
    </section>
</template>

<script>
    import { Close } from '../../Icons/Icons';

    export default {
        components: {
            Close
        },
        props: {
            id: Number
        },
        data() {
            return {
                open: false,
            }
        },
        methods: {
            triggerPopup(value, id) {
                if ( !window.localStorage.getItem('spin_autobesikos_stop_1') && this.$global.popup.id === 11 && !value ) {
                    window.localStorage.setItem('spin_autobesikos_stop_1', true);
                }
                if ( !window.localStorage.getItem('black_friday_autobesikos_2025') && this.$global.popup.id === 13 && !value ) {
                    window.localStorage.setItem('black_friday_autobesikos_2025', true);
                }
                if ( !window.localStorage.getItem('christmas_autobesikos_2025') && this.$global.popup.id === 14 && !value ) {
                    window.localStorage.setItem('christmas_autobesikos_2025', true);
                }
                if ( !window.localStorage.getItem('cars_offer_autobesikos_2026') && this.$global.popup.id === 15 && !value ) {
                    window.localStorage.setItem('cars_offer_autobesikos_2026', true);
                }
                if ( !window.localStorage.getItem('withdrawal_autobesikos_2026') && this.$global.popup.id === 16 && !value ) {
                    window.localStorage.setItem('withdrawal_autobesikos_2026', true);
                }
                this.$global.popup.open = value;
                this.$global.popup.id = id;
                this.updatedTrigger();
            },
            emitOpen(value) {
                this.$emit('popup_open', value);
            },
            updatedTrigger() {
                if ( this.$global.popup.open && !this.open ) {
                    this.open = true;
                    this.emitOpen(true);
                    document.body.classList.add("hide-scroll");
                } else if ( !this.$global.popup.open && this.open) {
                    this.open = false;
                    document.body.classList.remove("hide-scroll");
                    this.emitOpen(false);
                }
            }
        },
        mounted() {
            this.updatedTrigger();
        },
    }
</script>